import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AutoColorDirective, DynamicFormModule, TranslationsModule, ValkyrieUiModule } from '@symplicity/syng';
import { CSMSharedModule } from '@csm/shared';
import { EventsRoutingModule } from './events-routing.module';
import { ModalService } from './event-view/modal/modal.service';

/** Router outlets */
import { EventsComponent } from './events.component';
import { EventViewComponent } from './event-view/event-view.component';

/** Pages */
import { UpcomingComponent } from './upcoming/upcoming.component';
import { PastComponent } from './past/past.component';
import { EventOverviewComponent } from './event-overview/event-overview.component';
import { EventAttendingEmployersComponent } from './event-attending-employers/event-attending-employers.component';
import { EventAttendingEmployerViewComponent } from './event-attending-employer-view/event-attending-employer-view.component';

/** Components */
import { EventsListComponent } from './events-list/events-list.component';
import { EventViewHeaderComponent } from './event-view/event-view-header/event-view-header.component';
import { ActionButtonsComponent } from './event-view/action-buttons/action-buttons.component';
import { ModalComponent } from './event-view/modal/modal.component';
import { EmployersAttendingOverviewComponent } from './event-view/employers-attending-overview/employers-attending-overview.component';
import { MoreFilters } from './event-view/more-filters/more-filters.component';

const ROUTER_OUTLETS: Type<any>[] = [
    EventsComponent,
    EventViewComponent
];

const PAGES: Type<any>[] = [
    UpcomingComponent,
    PastComponent,
    EventOverviewComponent,
    EventAttendingEmployersComponent,
    EventAttendingEmployerViewComponent,
];

const COMPONENTS: Type<any>[] = [
    EventsListComponent,
    EventViewHeaderComponent,
    ActionButtonsComponent,
    ModalComponent,
    EmployersAttendingOverviewComponent,
    MoreFilters
];

const ENTRY_COMPONENTS: Type<any>[]= [
    ModalComponent
];

@NgModule({
    imports: [
        CommonModule,
        EventsRoutingModule,
        ValkyrieUiModule.forRoot(),
        TranslationsModule.forChild(),
        TranslateModule,
        TooltipModule,
        AutoColorDirective,
        BsDropdownModule,
        DynamicFormModule,
        CSMSharedModule
    ],
    providers: [
        ModalService
    ],
    declarations: [
        ...ROUTER_OUTLETS,
        ...PAGES,
        ...COMPONENTS
    ]
})
export class EventsModule {}
